import { styled, StyledText } from '@clickcease/cc-client-components-lib'

export const PlanDetailsStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '$12',
})

export const CurrentPlanWrapper = styled('div', {
  display: 'flex',
  fontWeight: '$sb',
  fontSize: '$lg',
  flexDirection: 'column',
})

export const CurrentPlanTitle = styled('div', {})

export const CurrentPlanPrice = styled('div', {
  fontWeight: '$rb',
  fontSize: '$md',
  marginTop: '$4',
})

export const ActionWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '$4',
  color: '$active',

  ['> svg']: {
    marginTop: '$1',
  },
})

export const ActionText = styled('div', {
  color: '$primaryColor',
  fontWeight: '$sb',
  fontSize: '$md',
  margin: '0',
  marginLeft: '$3',
  cursor: 'pointer',
})

export const ActionDescription = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  color: '$mainTextColor',
  margin: '$5 0px 0px 24px',
})

export const ErrorText = styled(StyledText, {
  marginLeft: '$12',
  marginTop: '$5',
  color: '$error',
})
